import { FC } from 'react';
import { TitleStyled } from './Title.styles';
import { TitleProps } from './Title.types';

export const Title: FC<TitleProps> = ({ label }) => <TitleStyled variant={'h2'}>{label}</TitleStyled>;
